import { Card } from "@mantine/core";
import type { ReactNode } from "react";

export function AuthPageFrame({ children }: { readonly children: ReactNode }) {
  return (
    <main className="app-shell auth-page-shell">
      <Card className="auth-page-card" padding="xl" radius="lg" shadow="sm" withBorder>
        {children}
      </Card>
    </main>
  );
}
